import React, { Component } from "react";

const preloadImagesWithPromise = (src) => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    // const timeout = setTimeout(() => {
    //     image.onload = null
    //     reject({error: `Was not able to load ${src} in 30s`})
    // }, 30000);

    image.onload = () => {
      //clearTimeout(timeout);
      resolve();
    };

    image.src = src;
  });
};

export default class BlurImage extends Component {
  state = {
    loaded: false,
  };

  componentDidMount() {
    this.loadImage();
  }

  loadImage = async () => {
    // try {
    await preloadImagesWithPromise(this.props.src);
    this.setState({ loaded: true });
    // } catch(error){
    //     console.error(error);
    // }
  };

  render() {
    const { loading, src, base64, alt } = this.props;
    const { loaded } = this.state;
    const currentSrc = loaded ? src : base64;

    return (
      <img
        {...this.props}
        loading={loading}
        src={currentSrc}
        alt={alt}
      />
    );
  }
}
